function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#0a2a38",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m362.063 83.188-.313-.063c-.188 0-.375 0-.5.125-4.125 2.125-7.625 1.25-10.563-2.563-7.25-9.5-13.875-17.562-19.937-24.124-10.5-11.376-21.813-20.876-33.938-28.626C281.125 18 262.563 12.813 244 16.376",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#0f3046",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M244 16.375c-11.563 2.188-22.438 7.25-32.125 13.75-8.75 5.813-16.438 12.125-23 18.813-6.875 7-11.625 12.062-14.25 15.187-11.375 13.375-21.875 28.063-31.563 44-15.687 25.938-28.875 53.063-39.437 81.313-.063.062 0 .187.063.25.062.062.187.062.312.062 22.5-13.625 49.25-22.063 74.938-27.063 50.687-9.875 101.562-10 152.562-.25 9.313 1.75 18.875 4.063 28.625 6.875",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#0a2a38",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M360.125 169.313a239.95 239.95 0 0 1 32.063 11.875c5.5 2.562 10.437 5.5 15.562 8.375.563.312.688.187.5-.375-9.5-25.75-21.813-51.75-36.375-76-2.875-4.75-3.625-9.376 1.375-12.876",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#0f3046",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M40.125 439.25c4.5 1.938 6.188 5.188 5.063 9.688-4.813 18.75-7.813 33.875-9 45.312-.188 1.813.624 2.688 2.374 2.688h29.75c.126 0 .188-.063.313-.188.063-.063.063-.188.063-.313-.563-4.187-.5-9.187 1.124-13.125 3.5-8.375 10.876-12.312 19.75-12.062.438 0 .626-.188.626-.563l-.063-106.375c0-.375-.125-.375-.375-.187C75.875 378 65.812 394.5 57.875 412.625c-1.375 3.125-2.563 5.125-3.625 6.063-2 1.687-4.5 2.125-7.625 1.375",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#80705c",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M275.938 172c3.75-.063 7.437-.125 11.125-.375.062 0 .125 0 .125-.063 0 0 0-.062-.063-.062l-.063-.063c-21.187-1.437-41.937-1.437-62.25 0-.687.063-.687.125 0 .125 2.938.25 5.813.313 8.5.313 3.313 0 5.938.375 7.938 1.125 5.438 2.125 8.625 6.313 9.625 12.438.063.375.25.562.688.562h8.937c.375 0 .563-.188.625-.563 1.188-7.562 6.938-13.375 14.813-13.437M338.938 187c.062.5.312.75.75.75h11.562c.25 0 .438-.188.438-.5v-4.125c0-.375-.188-.625-.563-.688l-13.938-3.5c-.437-.125-.562.063-.312.5 1.313 2.25 2 4.813 2.063 7.563M175.25 179.25c.188-.313.063-.438-.313-.313l-14.062 3.5c-.375.063-.563.313-.563.688V187c0 .5.25.75.688.75h11.25c.563 0 .813-.25.813-.75.062-2.688.75-5.25 2.187-7.75",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#272727",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M229.75 208.188c3.313-1.188 5.875-4.625 6-8.313.125-4.063.188-8.188.125-12.25 0-.375-.188-.625-.625-.625h-46.5c-.438 0-.688.25-.688.75v20.813c0 .187.188.437.438.437 10.625-.063 22.438-.063 35.563 0 2.125 0 4-.25 5.687-.813M276.313 200.25c.187 3.625 2.875 6.875 6.187 8.063 1.125.375 3.125.625 6 .625 11.688 0 23.313.062 35 0 .25 0 .438-.188.438-.438v-21.25a.269.269 0 0 0-.25-.25H276.75c-.375 0-.563.188-.563.563-.125 4.375-.062 8.562.125 12.687",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#80705c",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m144.938 187.25-11.375 4.313c-.313.125-.5.375-.5.75-.188 6.5-.75 13.75 6.187 16.812 1.938.875 4.438 1.25 7.438 1.125.375 0 .562-.25.5-.625-1.438-7.625-2.125-15-1.938-22.125 0-.063-.063-.188-.125-.188-.063-.062-.125-.062-.188-.062M378.438 191.563l-11.063-4.188c-.375-.125-.625 0-.625.438.125 7.625-.563 14.875-1.938 21.812-.062.313.063.563.438.563 2.813.25 5.25-.125 7.25-.938 7.125-3.063 6.688-10.375 6.438-16.938 0-.375-.188-.625-.5-.75",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#0a2a38",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M139.25 224.813c-12.563-2-20.875-12.438-21.25-25.188 0-.375-.188-.5-.563-.313-8 4.5-15.5 9.625-20.624 17.063-1.876 2.813-2.188 5.875-.876 9.188a91.082 91.082 0 0 0 8 16c13.25 21.375 29.313 42.5 48.25 63.312.875.938 1.563 1 2.813 1 14.688.063 30.125.063 46.375-.063 3.313 0 5.875-4.562 6.188-7.125.375-2.75.437-6 .25-9.687 0-.438-.188-.688-.563-.875-26.625-13.563-45.125-34.375-55.625-62.375-.125-.313-.375-.5-.688-.5-3.875 0-7.812.188-11.687-.438M360.375 225.75c-9.938 28.188-30.938 50.438-57.813 63.375-.375.188-.562.5-.562.875-.25 6-.563 11.75 5.25 15.375.688.5 1.688.5 2.5.5 14.625.063 30.438.063 47.563 0 .875 0 1.562-.313 2.125-.938 17.062-18.937 31.625-37.437 43.687-55.5a178.27 178.27 0 0 0 10.25-17.5 39.167 39.167 0 0 0 3.188-8.125c2.687-9.687-15.125-20.5-22-24.562-.375-.188-.563-.063-.563.313-.25 9.375-4.125 16.625-11.75 21.625-6.375 4.312-13.625 4.312-21.188 4.062-.312 0-.625.188-.687.5",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#80705c",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M250.75 201.813c-.625 9.75-7.75 17.812-16.75 20.937-2.938 1-7.188 1.5-12.813 1.375-9-.188-18.375-.188-28.25 0-5 .125-8.687-.375-10.937-1.438-4.438-2-7.313-5.375-8.5-10.187-.75-2.875-.5-6.125-.5-9.125 0-.313-.188-.5-.5-.5h-10.688a.477.477 0 0 0-.312.125c-.125.125-.125.25-.125.375 7.188 41.125 37.875 72.625 78.813 79.563 31.937 5.375 64-5.75 85.812-29.25 13-14.063 21.188-30.75 24.563-50.125.062-.438-.125-.688-.563-.688h-10.5c-.313 0-.5.188-.5.563a90.094 90.094 0 0 1 0 5.812c-.188 5.75-3.5 10.875-8.75 13.313-2.125 1.062-5.063 1.562-8.688 1.5-12.187-.063-24-.063-35.5-.063-12.812.063-23.625-9.375-24.812-22.188-.063-.375-.375-.687-.75-.687h-9c-.5 0-.75.25-.75.688M223.375 294.625c-.25-.125-.375 0-.375.313.063 3.625-.5 7.125-1.625 10.562-.063.063 0 .188.063.25.062.063.125.125.25.125h66.562c.375 0 .5-.188.375-.5-1.125-3-1.688-6.188-1.75-9.625-.063-.438-.25-.563-.688-.438-20.812 5.75-41.75 5.563-62.812-.687",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#686868",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M116 320.938c-7 0-10.75 4.25-10.75 11.125v138.625c0 .375.188.562.563.562h300.625c.187 0 .312-.125.312-.25a50415.7 50415.7 0 0 1 0-137.5c0-8.625-3.125-12.563-12-12.563-92.063.063-184.938.063-278.75 0",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#0a2a38",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M454.125 412.813c-7.375-17.625-18.063-35.25-31.938-48.75a.19.19 0 0 0-.25 0c-.062 0-.125.062-.125.187v106.313c0 .375.313.687.688.687 9.563 0 17.188 4.188 20.188 13.563 1.187 3.625 1.062 7.937.625 11.75 0 .125 0 .187.062.25.063.062.125.125.25.125h29.625c2.063-.063 3-1.063 2.688-3.188-3.75-28.188-11-55.125-21.813-80.938",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#4e4f50",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M428.5 490.5a4.188 4.188 0 0 0-4.188-4.188H87.688A4.188 4.188 0 0 0 83.5 490.5v2.188c0 2.312 1.875 4.25 4.188 4.25h336.625c2.312 0 4.187-1.938 4.187-4.25V490.5",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#195a7e",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M360.125 169.313c-8.375-20.125-18.75-40.75-31.125-61.813a333.252 333.252 0 0 0-35.625-50.063C282 44.25 269.5 32.688 255.125 23.126c-.938-.625-2.813-1.688-5.625-3.25-1.875-1.063-3.75-2.188-5.5-3.5",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#686868",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M287.188 402.875c0-17.25-13.938-31.188-31.188-31.188s-31.188 13.938-31.188 31.188S238.75 434.063 256 434.063s31.188-13.938 31.188-31.188",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "gray",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M272.125 402.875A16.084 16.084 0 0 0 256 386.75a16.084 16.084 0 0 0-16.125 16.125A16.084 16.084 0 0 0 256 419a16.084 16.084 0 0 0 16.125-16.125",
    transform: "scale(.0625)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M15.898 0h.274c1.672.098 3.098.934 4.281 1.996.695.625 1.406 1.414 2.137 2.375.117.152.183.277.195.367a.5.5 0 0 1-.148.434c-.02.02-.024.027-.008.027l-.02-.004c-.011 0-.023 0-.03.008-.259.133-.477.078-.661-.16a21.247 21.247 0 0 0-1.246-1.508 10.795 10.795 0 0 0-2.121-1.789c-.98-.621-2.14-.945-3.301-.723-.723.137-1.402.454-2.008.86a8.936 8.936 0 0 0-1.437 1.176c-.43.437-.727.753-.89.949a21.352 21.352 0 0 0-1.974 2.75 30.339 30.339 0 0 0-2.464 5.082c-.004.004 0 .012.003.015.004.004.012.004.02.004 1.406-.851 3.078-1.379 4.684-1.691a24.938 24.938 0 0 1 9.535-.016 19.4 19.4 0 0 1 1.789.43c.672.195 1.34.441 2.004.742.343.16.652.344.972.524.036.02.043.011.032-.024a28.425 28.425 0 0 0-2.274-4.75c-.18-.297-.226-.586.086-.804.277-.13.492-.075.633.156.789 1.285 1.531 2.793 2.234 4.531.223.55.422 1.145.602 1.773.078.27.137.543.18.825.066.43-.059.836-.243 1.222-.191.407-.441.844-.746 1.317-.699 1.066-1.468 2-2.289 2.988-.02.023-.015.04.02.04.39-.009.77-.009 1.133.003.87.02 1.503.695 1.511 1.566.004.27.004.532 0 .782 0 .015.004.027.016.035 1.535 1.18 2.539 2.902 3.2 4.73a21.785 21.785 0 0 1 1.105 4.508c.09.649-.36 1.184-1 1.254H2.312a1.116 1.116 0 0 1-.742-.379 1.009 1.009 0 0 1-.246-.824c.14-1.117.336-2.117.59-2.996.082-.281.277-.399.594-.348.281.121.387.324.316.606-.3 1.171-.488 2.117-.562 2.832-.012.113.039.168.148.168h1.86c.007 0 .011-.004.02-.012.003-.004.003-.012.003-.02-.035-.261-.031-.574.07-.82.219-.523.68-.77 1.235-.754.027 0 .039-.012.039-.035l-.004-6.648c0-.024-.008-.024-.024-.012-.867.867-1.496 1.898-1.992 3.031-.086.195-.16.32-.226.379-.125.105-.282.133-.477.086-.031-.027-.066-.055-.11-.09a.427.427 0 0 1-.179-.324c0-.09.016-.18.055-.27.68-1.593 1.593-3.043 2.93-4.05a.074.074 0 0 0 .03-.06c-.007-.292-.007-.581.005-.866.03-.867.738-1.485 1.601-1.477.352.004.691.004 1.027 0 .004 0 .008-.004.012-.012a.012.012 0 0 0 0-.015c-1.113-1.34-2.262-2.719-3.023-4.313a2.903 2.903 0 0 1-.239-.714c-.039-.215-.02-.454.024-.665.098-.511.242-1.035.433-1.566.657-1.867 1.543-3.723 2.66-5.57a21.812 21.812 0 0 1 2.282-3.14 12.032 12.032 0 0 1 2.133-1.923C13.418.598 14.492.102 15.539.035c.121-.008.238-.02.36-.035Zm1.348 10.75c.234-.004.465-.008.695-.023.004 0 .008 0 .008-.004 0 0 0-.004-.004-.004l-.004-.004a28.11 28.11 0 0 0-3.89 0c-.043.004-.043.008 0 .008.183.015.363.02.531.02.207 0 .371.023.496.07.34.132.54.394.602.777.004.023.015.035.043.035h.558c.024 0 .035-.012.04-.035.074-.473.433-.836.925-.84Zm3.938.938c.003.03.02.046.046.046h.723c.016 0 .027-.011.027-.03v-.259c0-.023-.011-.039-.035-.043l-.87-.218c-.028-.008-.036.004-.02.03.082.141.125.302.129.473Zm-10.23-.485c.01-.02.003-.027-.02-.02l-.88.22c-.023.003-.034.019-.034.042v.242c0 .032.015.047.043.047h.703c.035 0 .05-.015.05-.046a.999.999 0 0 1 .137-.485Zm3.405 1.809a.588.588 0 0 0 .375-.52c.008-.254.012-.512.008-.765 0-.024-.012-.04-.039-.04h-2.906c-.027 0-.043.016-.043.047v1.301c0 .012.012.027.027.027a210.21 210.21 0 0 1 2.223 0c.133 0 .25-.015.355-.05Zm2.91-.496a.59.59 0 0 0 .387.504c.07.023.196.039.375.039.73 0 1.457.004 2.188 0a.027.027 0 0 0 .027-.028v-1.328a.017.017 0 0 0-.016-.015h-2.933c-.024 0-.035.011-.035.035-.008.273-.004.535.008.793Zm-8.21-.813-.711.27a.047.047 0 0 0-.032.047c-.011.406-.046.859.387 1.05.121.055.277.078.465.07.023 0 .035-.015.031-.038a6.54 6.54 0 0 1-.12-1.383c0-.004-.005-.012-.009-.012-.004-.004-.008-.004-.011-.004Zm14.593.27-.691-.262c-.023-.008-.04 0-.04.027a6.44 6.44 0 0 1-.12 1.364c-.004.02.004.035.027.035a.97.97 0 0 0 .453-.059c.446-.191.418-.648.403-1.058a.047.047 0 0 0-.032-.047ZM8.703 14.05c-.785-.125-1.305-.778-1.328-1.574 0-.024-.012-.032-.035-.02-.5.281-.969.602-1.29 1.066a.589.589 0 0 0-.054.575c.133.347.3.683.5 1a27.173 27.173 0 0 0 3.016 3.957c.054.058.097.062.175.062.918.004 1.883.004 2.899-.004.207 0 .367-.285.387-.445.023-.172.027-.375.015-.605 0-.028-.011-.043-.035-.055-1.664-.848-2.82-2.149-3.476-3.899-.008-.02-.024-.03-.043-.03-.243 0-.489.01-.73-.028Zm13.82.058c-.62 1.762-1.933 3.153-3.613 3.961a.059.059 0 0 0-.035.055c-.016.375-.035.734.328.96.043.032.106.032.156.032.914.004 1.903.004 2.973 0a.17.17 0 0 0 .133-.058 30.671 30.671 0 0 0 2.73-3.47c.23-.347.446-.71.64-1.093.087-.164.153-.332.2-.508.168-.605-.945-1.281-1.375-1.535-.023-.012-.035-.004-.035.02-.016.586-.258 1.039-.734 1.351-.399.27-.852.27-1.325.254-.02 0-.039.012-.043.031Zm-6.851-1.496c-.04.61-.485 1.114-1.047 1.309-.184.062-.45.094-.8.086a44.32 44.32 0 0 0-1.766 0c-.313.008-.543-.024-.684-.09a.904.904 0 0 1-.531-.637c-.047-.18-.031-.383-.031-.57 0-.02-.012-.031-.032-.031h-.668a.03.03 0 0 0-.02.008c-.007.007-.007.015-.007.023.45 2.57 2.367 4.539 4.926 4.973 1.996.336 4-.36 5.363-1.829a6.04 6.04 0 0 0 1.535-3.132c.004-.028-.008-.043-.035-.043h-.656c-.02 0-.032.011-.032.035.004.117.004.238 0 .363a.945.945 0 0 1-.546.832c-.133.067-.317.098-.543.094-.762-.004-1.5-.004-2.22-.004a1.534 1.534 0 0 1-1.55-1.387c-.004-.023-.023-.043-.047-.043h-.562c-.031 0-.047.016-.047.043Zm-1.711 5.801c-.016-.008-.024 0-.024.02.004.226-.03.445-.101.66-.004.004 0 .011.004.015s.008.008.015.008h4.16c.024 0 .032-.012.024-.031a1.787 1.787 0 0 1-.11-.602c-.003-.027-.015-.035-.042-.027-1.301.36-2.61.348-3.926-.043ZM7.25 20.06c-.438 0-.672.265-.672.695v8.664c0 .023.012.035.035.035h18.79c.011 0 .019-.008.019-.015-.004-2.891-.004-5.754 0-8.594 0-.54-.195-.785-.75-.785-5.754.003-11.559.003-17.422 0ZM28.383 25.8c-.461-1.102-1.13-2.203-1.996-3.047a.012.012 0 0 0-.016 0c-.004 0-.008.004-.008.012v6.644c0 .024.02.043.043.043.598 0 1.074.262 1.262.848.074.226.066.496.039.734 0 .008 0 .012.004.016s.008.008.016.008h1.851c.129-.004.188-.067.168-.2a19.77 19.77 0 0 0-1.363-5.058Zm-1.602 4.855a.262.262 0 0 0-.261-.261H5.48a.262.262 0 0 0-.261.261v.137c0 .145.117.266.261.266h21.04a.265.265 0 0 0 .261-.266Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#135370",
      fillOpacity: 1
    },
    d: "m22.629 5.2.7 1.07c-.313.218-.267.507-.087.804.91 1.516 1.68 3.14 2.274 4.75.011.035.004.043-.032.024-.32-.18-.629-.364-.972-.524-.664-.3-1.332-.547-2.004-.742a31.678 31.678 0 0 0-1.945-3.863 20.828 20.828 0 0 0-2.227-3.13c-.711-.823-1.492-1.546-2.39-2.144a6.558 6.558 0 0 0-.352-.203 3.188 3.188 0 0 1-.344-.219c1.16-.222 2.32.102 3.3.723a10.795 10.795 0 0 1 2.122 1.79c.379.41.793.913 1.246 1.507.184.238.402.293.66.16.008-.008.02-.008.031-.008Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e608b",
      fillOpacity: 1
    },
    d: "M15.25 1.023c.11.082.227.153.344.22.176.097.293.163.351.202.899.598 1.68 1.32 2.39 2.145.825.957 1.571 2 2.227 3.129a31.678 31.678 0 0 1 1.946 3.863 19.4 19.4 0 0 0-1.79-.43 24.938 24.938 0 0 0-9.534.016c-1.606.312-3.278.84-4.684 1.691-.008 0-.016 0-.02-.004-.003-.003-.007-.011-.003-.015A30.339 30.339 0 0 1 8.94 6.758a21.352 21.352 0 0 1 1.973-2.75c.164-.196.461-.512.89-.95.41-.417.891-.812 1.438-1.175.606-.406 1.285-.723 2.008-.86Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffdfb8",
      fillOpacity: 1
    },
    d: "M17.941 10.727c-.23.015-.46.02-.695.023-.492.004-.851.367-.926.84-.004.023-.015.035-.039.035h-.558c-.028 0-.04-.012-.043-.035-.063-.383-.262-.645-.602-.777a1.438 1.438 0 0 0-.496-.07c-.168 0-.348-.005-.531-.02-.043 0-.043-.004 0-.008a28.11 28.11 0 0 1 3.89 0l.004.004c.004 0 .004.004.004.004 0 .004-.004.004-.008.004ZM21.184 11.688a.973.973 0 0 0-.13-.473c-.015-.027-.007-.04.02-.031l.871.218c.024.004.035.02.035.043v.258c0 .02-.011.031-.027.031h-.723c-.027 0-.043-.015-.046-.046ZM10.953 11.203a.999.999 0 0 0-.137.485c0 .03-.015.046-.05.046h-.704c-.027 0-.042-.015-.042-.046v-.243c0-.023.011-.039.035-.043l.879-.218c.023-.008.03 0 .02.02Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4d4d4d",
      fillOpacity: 1
    },
    d: "M14.734 12.492a.588.588 0 0 1-.375.52c-.105.035-.222.05-.355.05a210.21 210.21 0 0 0-2.223 0c-.015 0-.027-.015-.027-.027v-1.3c0-.032.016-.047.043-.047h2.906c.027 0 .04.015.04.039.003.253 0 .511-.009.765ZM17.656 13.02a.59.59 0 0 1-.386-.504 10.65 10.65 0 0 1-.008-.793c0-.024.011-.036.035-.036h2.933c.008 0 .016.008.016.016v1.328a.027.027 0 0 1-.027.028c-.73.004-1.457 0-2.188 0-.18 0-.304-.016-.375-.04Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffdfb8",
      fillOpacity: 1
    },
    d: "M9.059 11.703c.004 0 .007 0 .011.004.004 0 .008.008.008.012a6.54 6.54 0 0 0 .121 1.383c.004.023-.008.039-.031.039a1.032 1.032 0 0 1-.465-.07c-.433-.192-.398-.645-.387-1.051 0-.024.012-.04.032-.047ZM22.96 11.71l.692.263c.02.007.032.023.032.047.015.41.043.867-.403 1.058a.97.97 0 0 1-.453.059c-.023 0-.031-.016-.027-.035a6.44 6.44 0 0 0 .12-1.364c0-.027.017-.035.04-.027Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#135370",
      fillOpacity: 1
    },
    d: "M7.375 12.477c.023.796.543 1.449 1.328 1.574.242.039.488.027.73.027.02 0 .036.012.044.031.656 1.75 1.812 3.051 3.476 3.899.024.012.035.027.035.055.012.23.008.433-.015.605-.02.16-.18.445-.387.445-1.016.008-1.98.008-2.899.004-.078 0-.12-.004-.175-.062a27.173 27.173 0 0 1-3.016-3.957 5.693 5.693 0 0 1-.5-1 .589.589 0 0 1 .055-.575c.32-.464.789-.785 1.289-1.066.023-.012.035-.004.035.02ZM18.91 18.07c1.68-.808 2.992-2.199 3.613-3.96.004-.02.024-.032.043-.032.473.016.926.016 1.325-.254.476-.312.718-.765.734-1.351 0-.024.012-.032.035-.02.43.254 1.543.93 1.375 1.535a2.448 2.448 0 0 1-.2.508c-.194.383-.41.746-.64 1.094a30.671 30.671 0 0 1-2.73 3.469.17.17 0 0 1-.133.058c-1.07.004-2.059.004-2.973 0-.05 0-.113 0-.156-.031-.363-.227-.344-.586-.328-.961 0-.023.012-.043.035-.055Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffdfb8",
      fillOpacity: 1
    },
    d: "M14.625 13.922c.563-.195 1.008-.7 1.047-1.309 0-.027.015-.043.047-.043h.562c.024 0 .043.02.047.043.074.801.75 1.39 1.55 1.387.72 0 1.458 0 2.22.004.226.004.41-.027.543-.094a.945.945 0 0 0 .547-.832 5.631 5.631 0 0 0 0-.363c0-.024.011-.035.03-.035h.657c.027 0 .04.015.035.043a6.04 6.04 0 0 1-1.535 3.132 5.955 5.955 0 0 1-5.363 1.829c-2.559-.434-4.477-2.403-4.926-4.973 0-.008 0-.016.008-.024a.03.03 0 0 1 .02-.007h.667c.02 0 .031.011.031.03 0 .188-.015.392.032.571.074.301.254.512.531.637.14.066.371.098.684.09a44.32 44.32 0 0 1 1.765 0c.352.008.617-.024.801-.086ZM13.96 18.414a6.993 6.993 0 0 0 3.927.043c.027-.008.039 0 .043.027.004.215.039.414.11.602.007.02 0 .031-.024.031h-4.16c-.008 0-.012-.004-.016-.008s-.008-.011-.004-.015c.07-.215.105-.434.101-.66 0-.02.008-.028.024-.02Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#cfcfcf",
      fillOpacity: 1
    },
    d: "M6.578 20.754c0-.43.234-.695.672-.695 5.863.003 11.668.003 17.422 0 .555 0 .75.246.75.785-.004 2.84-.004 5.703 0 8.593 0 .008-.008.016-.02.016H6.613c-.023 0-.035-.012-.035-.035v-8.664ZM17.95 25.18c0-1.078-.87-1.95-1.949-1.95-1.078 0-1.95.872-1.95 1.95 0 1.078.872 1.949 1.95 1.949 1.078 0 1.95-.871 1.95-1.95Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e608b",
      fillOpacity: 1
    },
    d: "m2.508 27.453.406-1.2c.195.048.352.02.477-.085.066-.059.14-.184.226-.379.496-1.133 1.125-2.164 1.992-3.031.016-.012.024-.012.024.012l.004 6.648c0 .023-.012.035-.04.035-.554-.015-1.015.23-1.234.754-.101.246-.105.559-.07.82 0 .008 0 .016-.004.02-.008.008-.012.012-.02.012H2.41c-.11 0-.16-.055-.148-.168.074-.715.261-1.66.562-2.832.07-.282-.035-.485-.316-.606Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#135370",
      fillOpacity: 1
    },
    d: "M28.383 25.8a19.77 19.77 0 0 1 1.363 5.06c.02.132-.039.195-.168.199h-1.851c-.008 0-.012-.004-.016-.008s-.004-.008-.004-.016c.027-.238.035-.508-.039-.734-.188-.586-.664-.848-1.262-.848a.043.043 0 0 1-.043-.043v-6.644c0-.008.004-.012.008-.012a.012.012 0 0 1 .016 0c.867.844 1.535 1.945 1.996 3.047Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M17.95 25.18c0 1.078-.872 1.949-1.95 1.949a1.947 1.947 0 0 1-1.95-1.95c0-1.077.872-1.949 1.95-1.949 1.078 0 1.95.872 1.95 1.95Zm-.942 0c0-.559-.45-1.008-1.008-1.008-.559 0-1.008.45-1.008 1.008s.45 1.008 1.008 1.008c.559 0 1.008-.45 1.008-1.008Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M17.008 25.18c0 .558-.45 1.008-1.008 1.008-.559 0-1.008-.45-1.008-1.008 0-.559.45-1.008 1.008-1.008.559 0 1.008.45 1.008 1.008Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#9c9da0",
      fillOpacity: 1
    },
    d: "M5.48 30.395h21.04c.144 0 .261.117.261.261v.137a.265.265 0 0 1-.261.266H5.48a.265.265 0 0 1-.261-.266v-.137c0-.144.117-.261.261-.261Zm0 0"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRound);
export default __webpack_public_path__ + "static/media/user-round.95b2e396f1158e016a1b40c25cd6bd0a.svg";
export { ForwardRef as ReactComponent };